export default __webpack_public_path__ + "ai-scene4b7d9e.png";